import { GridSortCellParams } from "@mui/x-data-grid-pro";
import Warning, { WarningType } from "@/models/Warning";

export const WarningImportance: Record<WarningType, number> = {
  [WarningType.AD]: 1,
  [WarningType.TT_RED]: 2,
  [WarningType.TT_YELLOW]: 3,
  [WarningType.PM1]: 4,
  [WarningType.PM]: 5,
  [WarningType.SB]: 6,
};

export const warningSortComparator = (
  a?: Warning[],
  b?: Warning[],
  sortDirection?: GridSortCellParams<"asc" | "desc">,
) => {
  const getHighestPriority = (warnings?: Warning[]) => {
    return warnings && warnings?.length > 0
      ? Math.min(...warnings.map(w => WarningImportance[w.type]))
      : 6;
  };

  const priorityA = getHighestPriority(a);
  const priorityB = getHighestPriority(b);

  if (sortDirection?.value === "asc") {
    return priorityA - priorityB;
  } else {
    return priorityB - priorityA;
  }
};
